import { render, staticRenderFns } from "./FreightTrial.vue?vue&type=template&id=012ffc20&scoped=true&"
import script from "./FreightTrial.vue?vue&type=script&lang=js&"
export * from "./FreightTrial.vue?vue&type=script&lang=js&"
import style0 from "./FreightTrial.vue?vue&type=style&index=0&id=012ffc20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ffc20",
  null
  
)

export default component.exports